<div class="right-side p-5">
  <h2>Verification of unregistered MSME</h2>
  <div class="section">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8">
          <form [formGroup]="Verifyonspot">
            <div class="card p-4 shadow-lg">
              <div class="mb-3">
                <label for="txtudyamRegistrationNumber" class="form-label">UDYAM Registration Number <span class="text-danger">*</span></label>
                <input id="txtudyamRegistrationNumber" type="text" matInput autocomplete="off" placeholder="UDYAM-MH-01-XXXXXXX"
                       class="form-control" formControlName="udyamRegistrationNumber" required maxlength="19">
                <div *ngIf="f['udyamRegistrationNumber'].touched && f['udyamRegistrationNumber'].invalid" class="text-danger">
                  <small *ngIf="f['udyamRegistrationNumber'].errors?.['required']">Udyam number is required.</small>
                  <small *ngIf="f['udyamRegistrationNumber'].errors?.['pattern']">Invalid UDYAM registration number.</small>
                </div>
              </div>

              <div class="mb-3">
                <label for="txtownersMobileNumber" class="form-label">Mobile Number <span class="text-danger">*</span></label>
                <input id="txtownersMobileNumber" type="text" matInput placeholder="Enter Mobile Number"
                       class="form-control" formControlName="ownersMobileNumber" required maxlength="10" minlength="10">
                <div *ngIf="f['ownersMobileNumber'].touched && f['ownersMobileNumber'].invalid" class="text-danger">
                  <small *ngIf="f['ownersMobileNumber'].errors?.['required']">Mobile number is required.</small>
                  <small *ngIf="f['ownersMobileNumber'].errors?.['pattern']">Mobile number must be 10 digits and start with a non-zero digit.</small>
                </div>
              </div>

              <div class="text-center">
                <button (click)="verifyUser()" class="btn btn-success me-2">Verify User</button>
                <button type="reset" (click)="goBack()" class="btn btn-danger">Back</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
